<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="quizTaskDetails">

      <div class="pl-6 pr-6">
        <div v-if="this.$siteTypeId() != 1">
          <div class="pb-1">
            <label>Task Classification</label>
            <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification" :options="taskClassificationTypeList" v-model="taskClassificationTypeDropdown"></v-select>
          </div>
        </div>
        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.name"/>
        </div>

        <div>
          <label ref="quizLabel">iSpring Quiz</label>
          <vs-select placeholder="Search / Select Quiz" class="w-full mb-3" vs-multiple autocomplete v-model="formData.iSpringQuizId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in quizzes" />
          </vs-select>
        </div>
        
        <div class="mb-3">
          <vs-checkbox color="success" v-model="formData.autoAssess">Auto Assess</vs-checkbox>
          <div style="margin-top: 5px; margin-left: 5px;">
            <span class="text-danger text-sm" v-show="formData.autoAssess">When this is checked, the results <strong>will not</strong> go the assessor if the student <strong>PASSES</strong> the quiz. Also, please ensure that the selected iSpring Quiz <strong>does not</strong> contain questions that cannot be automatically assessed like <strong>Free Text</strong> and <strong>Likert Scale</strong> question types.</span>
          </div>
        </div>

        <div>
          <vs-checkbox color="success" v-model="formData.isDecisive">Decisive</vs-checkbox>
          <div style="margin-top: 5px; margin-left: 5px;">
            <span class="text-danger text-sm" v-show="formData.isDecisive">When this is checked, students won't be allowed to do the quiz on their smart phones / tablets. It also means that pictures of the student will be taken at random intervals.</span>
          </div>
        </div>

        <div class="pt-4" style="display: inline-grid;">
          <label>Task Number</label>
          <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" min="0" />
        </div>
        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>

          

          <div class="pb-1">
            <label>Assessment Criteria</label>
            <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaDropdown"></v-select>
          </div>
          <div class="pb-1">
            <label>Essential Embedded Knowledge</label>
            <v-select class="mb-2" ref="eekDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="eekDropdown"></v-select>
          </div>

          <div class="pb-1">
            <label>Unit Standard</label>
            <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardDropdown"></v-select>
          </div>
          
          <div class="pb-1">
            <label>Spesific Outcome</label>
            <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeDropdown"></v-select>
          </div>
          
        </div>
        <vs-divider>Go To</vs-divider>
        <vs-alert class="mb-3" :active.sync="active1" icon-pack="feather" color="warning" icon="icon-alert-circle">
          For Survey-type quizzes, ensure the <strong>'On Pass'</strong> & <strong>'On Fail'</strong> tasks are the same.
        </vs-alert>
        <div>
          <label>On Pass</label>
          <vs-select placeholder="Search / Select Pass Task" class="w-full pb-3" vs-multiple autocomplete v-model="formData.passTaskId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
          </vs-select>
          <div class="mb-3">
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.usePassCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.usePassCoins && formData.passTaskId">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isPassCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addPassCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Pass Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.passCoinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Pass Coin Value')">{{ errors.first('Pass Coin Value') }}</span>
            </div>
          </div>
        </div>
        <div>
          <label>On Fail</label>
          <vs-select placeholder="Search / Select Fail Task" class="w-full pb-3" vs-multiple autocomplete v-model="formData.failTaskId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useFailCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useFailCoins && formData.failTaskId">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isFailCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addFailCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Fail Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.failCoinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Fail Coin Value')">{{ errors.first('Fail Coin Value') }}</span>
            </div>
          </div>
        </div>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditQuizTask" :disabled="isDisabled" ref="addUpdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
    taskClassificationTypes: {
      type: Array,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    gotoList: {
      type: Array,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        iSpringQuizId: "",
        passTaskId: "",
        failTaskId: "",
        moduleId: "",
        sourceTaskId: 0,
        hasLogs: false,
        usePassCoins: false,
        isPassCoinsRecurring: false,
        addPassCoins: true,
        passCoinValue: "",
        useFailCoins: false,
        isFailCoinsRecurring: false,
        addFailCoins: true,
        failCoinValue: "",
        isDecisive: false,
        number: 0,
        taskClassificationTypeId: null,
        autoAssess: false
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      quizzes: [],
      active1: false,
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eekDropdown: null,
      taskClassificationTypeDropdown: null,
      spesificOutcome: [],
      unitStandard: [],
      assessmentCriteria: [],
      eek: [],
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      taskClassificationTypeText: null,
    };
  },
  computed: {
    isDisabled: function() {
      return !(this.formData.passTaskId && this.formData.failTaskId && this.formData.iSpringQuizId);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        var self = this;
        self.active1 = true;
        var passGoToDisplayValue = 0;
        var failGoToDisplayValue = 0;
        if(self.nodeSelected.iSpringQuizTask){
          passGoToDisplayValue = self.nodeSelected.iSpringQuizTask.passTaskGoto;
          failGoToDisplayValue = self.nodeSelected.iSpringQuizTask.failTaskGoto;
        }
        else
          passGoToDisplayValue = failGoToDisplayValue = 0;

        var onSuccess = response => { self.quizzes = response.data; };
        self.$ajaxGet(self, "ispringquiz/getselectlist", onSuccess);

        self.formData.moduleId = self.moduleId;
        self.formData.courseId = self.courseId;

        self.taskClassificationTypeList = self.taskClassificationTypes;

        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.getAssessmentCriteria();
        
        if(self.nodeSelected.id){
          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.formData.sourceTaskId = self.sourceTaskId;
          self.formData.iSpringQuizId = self.nodeSelected.iSpringQuizTask.iSpringQuizId;
          self.formData.hasLogs = self.nodeSelected.iSpringQuizTask.hasLogs;
          self.formData.isDecisive = self.nodeSelected.iSpringQuizTask.isDecisive;
          self.formData.autoAssess = self.nodeSelected.iSpringQuizTask.autoAssess;

          self.formData.usePassCoins = self.nodeSelected.iSpringQuizTask.passCoinValue ? true : false;
          self.formData.addPassCoins = self.nodeSelected.iSpringQuizTask.passCoinValue > 0 ? true : false;
          self.formData.isPassCoinsRecurring = self.nodeSelected.iSpringQuizTask.isPassCoinsRecurring;
          self.formData.passCoinValue = self.nodeSelected.iSpringQuizTask.passCoinValue > 0 ? self.nodeSelected.iSpringQuizTask.passCoinValue : (self.nodeSelected.iSpringQuizTask.passCoinValue * -1);

          self.formData.useFailCoins = self.nodeSelected.iSpringQuizTask.failCoinValue ? true : false;
          self.formData.addFailCoins = self.nodeSelected.iSpringQuizTask.failCoinValue > 0 ? true : false;
          self.formData.isFailCoinsRecurring = self.nodeSelected.iSpringQuizTask.isFailCoinsRecurring;
          self.formData.failCoinValue = self.nodeSelected.iSpringQuizTask.failCoinValue > 0 ? self.nodeSelected.iSpringQuizTask.failCoinValue : (self.nodeSelected.iSpringQuizTask.failCoinValue * -1);

          self.taskClassificationTypeDropdown = self.taskClassificationTypeList.filter(function(item){
            return item.value == self.nodeSelected.taskClassificationTypeId;
          })[0];

          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;

          if(passGoToDisplayValue != 0)
            self.formData.passTaskId = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == passGoToDisplayValue; })[0].value;
          if(failGoToDisplayValue != 0)
            self.formData.failTaskId = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == failGoToDisplayValue; })[0].value;

        }else{
          this.initValues(self.sourceTaskId || 0);
        }
      }else {
        var scrollOptions = {
          container: '#quizTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 0, scrollOptions);
      }
    },
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}})
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeDropdown = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}})
        if(self.nodeSelected.id){
          self.unitStandardDropdown = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}})
        if(self.nodeSelected.id){
          self.spesificOutcomeDropdown = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    getAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}})
        if(self.nodeSelected.id){
          self.assessmentCriteriaDropdown = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },
    initValues(val) {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.sourceTaskId = 0;
      this.formData.iSpringQuizId = "";
      this.formData.passTaskId = "";
      this.formData.failTaskId = "";
      this.formData.isDecisive = false;
      this.formData.autoAssess = false;

      this.formData.usePassCoins = false;
      this.formData.addPassCoins = true;
      this.formData.isPassCoinsRecurring = false;
      this.formData.passCoinValue = "";
      this.formData.useFailCoins = false;
      this.formData.addFailCoins = true;
      this.formData.isFailCoinsRecurring = false;
      this.formData.failCoinValue = "";
      this.active1 = true;
      this.formData.number = 0;
      this.spesificOutcomeDropdown = null;
      this.unitStandardDropdown = null;
      this.assessmentCriteriaDropdown = null;
      this.essentialEmbeddedKnowledgeDropdown = null;
      this.taskClassificationTypeDropdown = null;

      if(val){
        this.formData.sourceTaskId = val;
      }
    
      this.errors.clear();
    },
    saveData(val){
      this.$emit('saveData',val);
      this.$vs.loading.close(this.$refs.addUpdateButton.$el);
      this.initValues(val);
    },
    addEditQuizTask() {
      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();

          var onSuccess = response => {
            self.saveData( response.data );
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Task Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addUpdateButton.$el);
          };

          self.formData.unitStandardId = self.unitStandardDropdown ? self.unitStandardDropdown.value: null

          self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeDropdown ? self.essentialEmbeddedKnowledgeDropdown.value: null;

          self.formData.assessmentCriteriaId = self.assessmentCriteriaDropdown ?  self.assessmentCriteriaDropdown.value: null;

          self.formData.spesificOutcomeId = self.spesificOutcomeDropdown ?  self.spesificOutcomeDropdown.value: null;

          self.formData.taskClassificationTypeId = self.taskClassificationTypeDropdown ? self.taskClassificationTypeDropdown.value: null;

          self.$ajaxPost(self, "ispringquiztask/addeditispringquiztask", self.formData, onSuccess, onFinally);
        }
      });
      var scrollOptions = {
        container: '#quizTaskDetails',
        easing: 'ease-in',
        offset: -1000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, scrollOptions);
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      }

      self.$ajaxDelete(self, "ispringquiztask/deleteispringquiztask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addUpdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected iSpring Quiz task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    },
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
